<template>
  <!-- <el-button type="default" plain icon="EditPen">编辑</el-button> -->
  <div class="page_box">
    <div class="col left">
      <div class="body">
        <div class="title">组件</div>
        <div class="modules">
          <div class="item" @click="onAddElement('image', '图片')">
            <div class="img"></div>
            <div class="name">图片</div>
          </div>
          <div class="item" @click="onAddElement('text', '文字')">
            <div class="img text">A</div>
            <div class="name">文字</div>
          </div>
          <div class="item" @click="onAddElement('video', '视频')">
            <div class="img text"></div>
            <div class="name">视频</div>
          </div>
        </div>
      </div>
    </div>
    <div class="middle">
      <div class="edit">
        <template v-for="(item, index) in list" :key="item">
          <div
            :class="`element ${
              currentElement && item.uid == currentElement.uid ? 'active' : ''
            }`"
            @click="currentElement = item"
          >
            <div v-if="item.element == 'image'" class="image">
              <el-image
                :src="item.file_url"
                alt=""
                v-if="item.file_url"
                style="width: 100%"
                fit="fill"
              ></el-image>
              <div class="empty" v-else>
                <el-icon size="60"><Picture /></el-icon>
              </div>
            </div>
            <div class="text" v-if="item.element == 'text'">
              <div v-if="item.text" :style="item.style">
                {{ item.text }}
              </div>
              <div v-else class="empty">请在右侧添加文字</div>
            </div>
            <div v-if="item.element == 'video'" class="video">
              <video
                style="padding: 0; width: 100%; margin: 0"
                :src="item.file_url"
                v-if="item.file_url"
                controls
              >
                <source :src="item.file_url" type="video/mp4" />
              </video>
              <div class="empty" v-else>
                <el-icon size="60"><VideoCamera /></el-icon>
              </div>
            </div>
            <div
              class="toolbar"
              v-if="currentElement && item.uid == currentElement.uid"
            >
              <el-button
                icon="Top"
                size="small"
                link
                @click.stop="onMoveElement(item, -1)"
                :disabled="index === 0"
                >上移</el-button
              >
              <div>
                <el-button
                  icon="Bottom"
                  size="small"
                  link
                  @click.stop="onMoveElement(item, 1)"
                  :disabled="index === list.length - 1"
                  >下移</el-button
                >
              </div>
              <div>
                <el-button
                  icon="Delete"
                  type="danger"
                  size="small"
                  link
                  @click.stop="onRemoveElement(index)"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="col right">
      <div class="body">
        <el-scrollbar v-if="currentElement">
          <div class="title">{{ currentElement.name }}</div>
          <div class="form">
            <el-form :model="currentElement" label-position="top">
              <template v-if="currentElement.element == 'text'">
                <el-form-item label="文本内容">
                  <el-input
                    v-model="currentElement.text"
                    type="textarea"
                    :rows="6"
                  ></el-input>
                </el-form-item>
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="颜色">
                      <el-color-picker
                        v-model="currentElement.style.color"
                        @change="onChange"
                      />
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <el-form-item label="大小">
                      <el-select
                        v-model="currentElement.style.fontSize"
                        @change="onChange"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in sizeOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="行间距">
                      <el-select
                        v-model="currentElement.style.lineHeight"
                        @change="onChange"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in sizeOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="内边距">
                  <el-row :gutter="10" style="width: 100%">
                    <el-col :span="6">
                      <el-form-item label="左">
                        <el-select
                          v-model="currentElement.style.paddingLeft"
                          @change="onChange"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in paddingOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="上">
                        <el-select
                          v-model="currentElement.style.paddingTop"
                          @change="onChange"
                          style="width: 100%"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in paddingOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="6">
                      <el-form-item label="右">
                        <el-select
                          v-model="currentElement.style.paddingRight"
                          @change="onChange"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in paddingOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="下">
                        <el-select
                          v-model="currentElement.style.paddingBottom"
                          @change="onChange"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in paddingOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>

                <el-form-item label="对齐方式">
                  <el-radio-group
                    v-model="currentElement.style.textAlign"
                    @change="onChange"
                  >
                    <el-radio-button label="左对齐" value="left" />
                    <el-radio-button label="居中对齐" value="center" />
                    <el-radio-button label="右对齐" value="right" />
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="背景色">
                  <el-color-picker
                    v-model="currentElement.style.backgroundColor"
                    @change="onChange"
                  />
                </el-form-item>
              </template>
              <el-form-item
                label="上传图片"
                v-if="currentElement.element == 'image'"
              >
                <upload-single
                  :clearable="false"
                  :src="currentElement.file_url"
                  @change="onUploadChange"
                ></upload-single>
                <div class="help-block">宽度480px以上，大小3M以内</div>
              </el-form-item>
              <el-form-item
                label="上传视频"
                v-if="currentElement.element == 'video'"
              >
                <upload-video
                  :src="currentElement.file_url"
                  @change="onUploadChange"
                ></upload-video>
                <div class="help-block">大小50M以内</div>
              </el-form-item>
            </el-form>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
  <el-dialog
    title=""
    width="30%"
    top="0vh"
    :destroy-on-close="true"
    :close-on-click-modal="false"
  >
    <span></span>
    <template #footer> </template>
  </el-dialog>
</template>

<script setup>
import { ref, watch } from "vue";
import { nanoid } from "nanoid";
import UploadSingle from "@/views/components/upload_single.vue";
import UploadVideo from "@/views/components/upload_video_single.vue";
const model = defineModel();
const visible = ref(false);
const currentElement = ref(null);
const props = defineProps({
  /**
   *
   */
  page: {
    type: String,
    required: true,
  },
});
const list = ref([]);
const sizeOptions = ref([
  // {
  //   label: "12",
  //   value: "12px",
  // },
  // {
  //   label: "13",
  //   value: "13px",
  // },
  // {
  //   label: "14",
  //   value: "14px",
  // },
  // {
  //   label: "15",
  //   value: "15px",
  // },
  // {
  //   label: "16",
  //   value: "16px",
  // },
  // {
  //   label: "17",
  //   value: "17px",
  // },
  // {
  //   label: "18",
  //   value: "18px",
  // },
  // {
  //   label: "20",
  //   value: "20px",
  // },
  // {
  //   label: "24",
  //   value: "24px",
  // },
  // {
  //   label: "28",
  //   value: "28px",
  // },
  // {
  //   label: "32",
  //   value: "32px",
  // },
  // {
  //   label: "36",
  //   value: "36px",
  // },
  // {
  //   label: "40",
  //   value: "40px",
  // },
  // {
  //   label: "34",
  //   value: "34px",
  // },
  // {
  //   label: "48",
  //   value: "48px",
  // },
  // {
  //   label: "52",
  //   value: "52px",
  // },
  // {
  //   label: "58",
  //   value: "58px",
  // },
  // {
  //   label: "60",
  //   value: "60px",
  // },
]);
//边距
const paddingOptions = ref([
  // {
  //   label: "0",
  //   value: "0px",
  // },
  // {
  //   label: "2",
  //   value: "2px",
  // },
  // {
  //   label: "4",
  //   value: "4px",
  // },
  // {
  //   label: "6",
  //   value: "6px",
  // },
  // {
  //   label: "8",
  //   value: "8px",
  // },
  // {
  //   label: "10",
  //   value: "10px",
  // },
  // {
  //   label: "12",
  //   value: "12px",
  // },
  // {
  //   label: "14",
  //   value: "14px",
  // },
  // {
  //   label: "16",
  //   value: "16px",
  // },
  // {
  //   label: "18",
  //   value: "18px",
  // },
  // {
  //   label: "20",
  //   value: "20px",
  // },
  // {
  //   label: "22",
  //   value: "22px",
  // },
  // {
  //   label: "24",
  //   value: "24px",
  // },
  // {
  //   label: "26",
  //   value: "26px",
  // },
  // {
  //   label: "28",
  //   value: "28px",
  // },
  // {
  //   label: "30",
  //   value: "30px",
  // },
  // {
  //   label: "32",
  //   value: "32px",
  // },
]);

for (let i = 10; i <= 60; i++) {
  sizeOptions.value.push({
    label: i + "",
    value: i + "px",
  });
}
for (let i = 0; i <= 30; i++) {
  paddingOptions.value.push({
    label: i + "",
    value: i + "px",
  });
}

watch(
  () => model.value,
  (val) => {
    if (val) {
      list.value = val;
      list.value.forEach((item) => {
        item.uid = nanoid();
        if (item.style_json) {
          item.style = JSON.parse(item.style_json);
        }
        item.name =
          item.element == "image"
            ? "图片"
            : item.element == "video"
            ? "视频"
            : item.element == "text"
            ? "文字"
            : "";
      });
    }
    // list.value = [...val];
  },
  {
    immediate: true,
  }
);

/**
 * 添加元素
 */
function onAddElement(element, name) {
  var item = {
    uid: nanoid(),
    page: props.page,
    element: element,
    name: name,
    style: {
      width: "100%",
      height: "auto",
    },
  };

  if (element == "text") {
    item.style = Object.assign(item.style, {
      width: "100%",
      height: "auto",
      textAlign: "left",
      lineHeight: "16px",
      fontSize: "14px",
      paddingTop: "10px",
      paddingRight: "10px",
      paddingLeft: "10px",
      paddingBottom: "10px",
    });
  }

  list.value.push(item);

  currentElement.value = item;
  onChange();
}

/**
 * 移除元素
 * @param item
 */
function onRemoveElement(index) {
  list.value.splice(index, 1);
  currentElement.value = null;
  onChange();
}

/**
 * 上传成功
 * @param url
 */
function onUploadChange(url) {
  if (url) {
    currentElement.value.file_url = url;
  }
  onChange();
}

/**
 * 移动元素
 */
function onMoveElement(item, len) {
  let index = list.value.findIndex((o) => o == item);
  if (len == -1) {
    //上移动
    if (index > 0) {
      list.value.splice(index, 1);
      list.value.splice(index - 1, 0, item);
    }
  } else {
    //下移动
    if (index < list.value.length - 1) {
      list.value.splice(index, 1);
      list.value.splice(index + 1, 0, item);
    }
  }
  onChange();
}

/**
 *
 */
function onChange() {
  list.value.forEach((item) => {
    if (item.style) {
      item.style_json = JSON.stringify(item.style);
    }
  });
  model.value = [...list.value];
}
</script>

<style scoped>
.page_box {
  /* width: 375px; */
  height: 700px;
  background: var(--el-color-info-light-9);
  border: 1px solid var(--el-color-info-light-9);
  display: flex;
  justify-content: space-between;
}

.page_box .col {
  width: 240px;
}
/* .page_box .col.left{
  width: 240px;
} */

.page_box .col .body {
  background: white;
  height: 100%;
  width: 100%;
}

.body .title {
  padding: 10px 20px;
  border-bottom: 1px solid var(--el-color-info-light-9);
}

.modules {
  padding: 10px 20px;
  display: grid;
  flex-wrap: wrap;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 20px;
  column-gap: 20px;
}
.modules .item {
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.modules .item:hover {
  background: var(--el-color-info-light-9);
}
.modules .item:hover > .img {
  background: var(--el-color-primary-light-3);
}
.modules .item .img {
  width: 50px;
  height: 50px;
  background: var(--el-color-info-light-3);
}
.modules .item .name {
  text-align: center;
  font-size: 12px;
  line-height: 12px;
  margin-top: 10px;
}

.modules .item .img.text {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  color: white;
}

.col.right {
  display: flex;
  justify-content: flex-end;
  width: 300px;
}

.col.right .form {
  padding: 10px;
  height: 100%;
}

.middle {
  flex-grow: 1;
  width: 1px;
  overflow-y: auto;
  padding: 20px 0;
}

.edit {
  width: 375px;
  min-height: 650px;
  background: white;
  box-shadow: var(--el-box-shadow-light);
  position: relative;
  margin: 0 auto;
}

.edit .element {
  position: relative;
}
.edit .element.active {
  border: 2px solid var(--el-color-primary-light-3);
}

.edit .element .image {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--el-color-info-light-9);
}

.edit .element .empty {
  height: 120px;
  background: var(--el-color-info-light-9);
  display: flex;
  align-items: center;
  justify-content: center;
}
.edit .element .text {
  width: 100%;
  flex-grow: 1;
  white-space: pre-wrap;
}

.edit .element .video {
  display: flex;
  flex-direction: column;
}

/* .edit .side{
  width: 100%;
  width: 375px;
} */

.edit .element .toolbar {
  position: absolute;
  right: -8px;
  top: -5px;
  background: white;
  box-shadow: var(--el-box-shadow-light);
  z-index: 10;
  display: flex;
  width: 50px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* border-radius: 5px 0 0 0px; */
  padding: 5px;
  padding: 10px 0;
  transform: translateX(100%);
}
.edit .element .toolbar::before {
  width: 10px;
  height: 10px;
  content: "";
  position: absolute;
  left: -5px;
  top: 8px;
  background: white;
  transform: rotate(45deg);
}

.el-form-item .el-form-item {
  padding-bottom: 18px;
}
</style>
